<template>
  <v-app data-test="layout-admin" class="admin-app">
    <v-navigation-drawer
      v-if="!isTablet"
      clipped
      app
      :value="sidebarOpen"
      @input="sidebarOpen = $event"
      :mini-variant="sidebarCollapsed"
      class="admin-sidebar"
    >
      <div
        class="sidebar-hover-area"
        @mouseenter="expandSidebar"
        @mouseleave="collapseSidebar"
      >
        <v-list dense class="sidebar-list">
          <template v-for="(link, index) in sidebarLinks">
            <v-list-item
              :key="index"
              :to="link.to"
              v-if="isVisibleLink(link)"
              class="sidebar-item"
            >
              <v-list-item-action>
                <v-icon small v-text="link.icon" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="sidebar-title">{{ t(link.titleKey) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <template v-slot:append>
        <div
          class="sidebar-toggle-container"
          @mouseenter="expandSidebar"
          @mouseleave="collapseSidebar"
        >
          <v-btn icon small @click="toggleSidebar" class="sidebar-toggle-btn">
            <v-icon small v-text="toggleIcon" />
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="#231f20" dark :clipped-left="!isTablet" class="admin-app-bar" elevation="1">
      <div class="logo-and-lang" style="display: flex; align-items: center;">
        <div @click="backToApp" style="cursor: pointer">
          <LogoLarge />
        </div>
        <LanguageDropdown class="ml-8" />
      </div>
      <v-menu
        v-if="isTablet"
        offset-y
        content-class="admin-menu-dropdown"
        right
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="admin-menu-btn"
            v-on="on"
          >
            <v-icon>$vuetify.icons.menu</v-icon>
          </v-btn>
        </template>
        <v-list dense class="admin-menu-list">
          <template v-for="(link, index) in sidebarLinks">
            <v-list-item
              :key="index"
              :to="link.to"
              v-if="isVisibleLink(link)"
              class="admin-menu-item"
            >
              <v-list-item-action>
                <v-icon small v-text="link.icon" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="admin-menu-title">{{ t(link.titleKey) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <div class="company-name-center">
        <img v-if="logo" :src="logo" class="team-logo"/>
        <span v-else class="company-name">{{ companyName }}</span>
      </div>
      <v-spacer />
      <UserMenu :user="user" :subtitle="user.companyName">
        <UserMenuItem icon="map_marker_alt" @click="backToApp">
          {{ t('layouts.admin.backToMap') }}
        </UserMenuItem>
        <UserMenuItem v-if="premiere == 1" icon="eye" :to="{ name: 'overwatch' }">
          {{ t('layouts.admin.overwatch') }}
        </UserMenuItem>
        <UserMenuItem v-if="premiere == 1" icon="viewer" :to="{ name: 'liveteam' }">
          {{ t('layouts.app.teamTrack') }}
        </UserMenuItem>
        <UserMenuItem icon="file" @click="toTraining">
          {{ t('layouts.admin.trainingVideos') }}
        </UserMenuItem>
        <UserMenuItem icon="sign_out" danger @click="signOut">
          {{ t('layouts.admin.signOut') }}
        </UserMenuItem>
      </UserMenu>
    </v-app-bar>
    <!-- <iframe 
      src="/chatbot.html" 
      allowtransparency="true"
      style="position: fixed; bottom: 0; right: 30px; width: 400px; height: 600px; border: none; z-index: 9999; background: transparent;"
    /> -->
    <v-main class="admin-main">
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import store from "@/store";
import axios from "axios";

export default Vue.extend({
  data() {
    return {
      companyName: null,
      sidebarOpen: true,
      sidebarCollapsed: true,
      sidebarLinks: [
        {
          to: { name: "admin-users" },
          titleKey: "layouts.admin.users",
          permissionKey: "users",
          icon: "$vuetify.icons.user",
        },
        {
          to: { name: "admin-verification-edit" },
          titleKey: "layouts.admin.verification",
          permissionKey: "verification",
          icon: "$vuetify.icons.lock",
        },
        {
          to: { name: "admin-teams" },
          titleKey: "layouts.admin.teams",
          permissionKey: "teams",
          icon: "$vuetify.icons.users",
        },
        {
          to: { name: "admin-api" },
          titleKey: "layouts.admin.api",
          permissionKey: "api",
          icon: "$vuetify.icons.database",
        },
        {
          to: { name: "admin-metrics" },
          titleKey: "layouts.admin.teamUserMetrics",
          permissionKey: "teamUserMetrics",
          icon: "$vuetify.icons.addressCard",
        },
        {
          to: { name: "admin-metrics-fake-data" },
          titleKey: "layouts.admin.demoMetrics",
          permissionKey: "demoMetrics",
          icon: "$vuetify.icons.poll",
        },
        {
          to: { name: "admin-platform-metrics" },
          titleKey: "layouts.admin.platformMetrics",
          permissionKey: "platformMetrics",
          icon: "$vuetify.icons.database",
        },
        {
          to: { name: "admin-overwatch" },
          titleKey: "OVERWATCH",
          permissionKey: "overwatch",
          icon: "$vuetify.icons.search",
        },
        {
          to: { name: "admin-dev" },
          titleKey: "layouts.admin.dev",
          permissionKey: "dev",
          icon: "$vuetify.icons.code",
        },
      ],
      classic: 0,
      premiere: 0,
      enterprise: 0,
    };
  },
  created() {
    this.companyName = store.state.authentication.currentUser.companyName
  },
  methods: {
    t(key: string): string {
      return (this as any).$t(key);
    },
    signOut() {
      store.dispatch("authentication/logout");
      this.$router.push({
        name: "auth-sign-in",
      });
    },
    toTraining() {
      this.$router.push({
        name: "training",
      });
    },
    backToApp() {
      this.$router.push({ name: "dashboard" });
    },
    toggleSidebar() {
      if (this.sidebarOpen) {
        this.sidebarCollapsed = !this.sidebarCollapsed;
      }
    },
    expandSidebar() {
      if (this.sidebarOpen && this.sidebarCollapsed) {
        this.sidebarCollapsed = false;
      }
    },
    collapseSidebar() {
      if (this.sidebarOpen && !this.sidebarCollapsed) {
        this.sidebarCollapsed = true;
      }
    },
    isVisibleLink(link) {
      const teamName = store.state.authentication.teams[0].teamName;
      axios.get(`/api/v1/teams/checkPermissionLevel/${teamName}/premiere`).then((res) => {
        this.premiere = res.data; //returns either a 1 or 0 (T/F)
      });
      axios
        .get(`/api/v1/teams/checkPermissionLevel/${teamName}/enterprise`)
        .then((res) => {
          this.enterprise = res.data;
        });

      switch (link.permissionKey) {
        case "verification":
        case "dev":
        case "platformMetrics":
          return this.isAdmin;
        case "demoMetrics":
          return this.companyName === 'i911 Inc.'
        case "overwatch":
        case "teamUserMetrics":
          return this.enterprise;
        case "api":
          return this.allowApi;
        default:
          return true;
      }
    },
  },
  computed: {
    user() {
      return store.state.authentication.currentUser;
    },
    toggleIcon() {
      return this.sidebarCollapsed
        ? "$vuetify.icons.chevron_right"
        : "$vuetify.icons.chevron_left";
    },
    logo() {
      const team = store.state.authentication.teams[0];
      const logoName = (team as any).logoName;
      if (!logoName) {
        return null;
      }
      return require(`@/../public/img/${logoName}`);
    },
    isTablet() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md;
    },
    isAdmin() {
      return store.state.authentication.currentUser.isAdmin
    },
    allowApi() {
      return store.state.authentication.teams[0].allowApi
    }
  },
});
</script>

<style lang="scss" scoped>
.admin-app {
  background: #f5f7fa;
}

// Sidebar
.admin-sidebar {
  background: #231f20 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
}

// Make collapsed sidebar wider
:deep(.v-navigation-drawer--mini-variant) {
  width: 70px !important;
}

.sidebar-hover-area {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-list {
  padding: 8px;
}

.sidebar-item {
  margin: 2px 0;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: #ffffff !important;

  .v-icon {
    color: #ffffff !important;
    transition: color 0.2s ease;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #ffffff !important;

    .v-icon {
      color: #ffffff !important;
    }
  }

  &.v-list-item--active {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    color: white !important;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);

    .sidebar-title {
      color: white !important;
      font-weight: 600;
    }

    .v-icon {
      color: white !important;
    }
  }
}

// Center icons when sidebar is collapsed
:deep(.v-navigation-drawer--mini-variant) {
  .sidebar-item {
    justify-content: center !important;
    padding-left: 0 !important;
    padding-right: 0 !important;

    .v-list-item__action {
      margin: 0 auto !important;
      min-width: auto !important;
    }

    .v-list-item__content {
      display: none !important;
    }
  }
}

.sidebar-title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: inherit;
}

.sidebar-toggle-container {
  padding: 8px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

// Center toggle button when sidebar is collapsed
:deep(.v-navigation-drawer--mini-variant) {
  .sidebar-toggle-container {
    justify-content: center !important;
  }
}

.sidebar-toggle-btn {
  color: #cbd5e1 !important;

  .v-icon {
    font-size: 18px !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #ffffff !important;
  }
}

// App Bar
.admin-app-bar {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  // position: relative;

  :deep(.v-toolbar__content) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

.company-name-center {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
  pointer-events: none;
  white-space: nowrap;
}

.company-name {
  margin: 0;
  padding: 0;
  font-size: 19px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.5px;
  text-transform: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  opacity: 0.95;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
}

.company-name-center {
  .team-logo {
    max-height: 60%;
    max-width: 20vw;
    height: auto;
    width: auto;
    object-fit: contain;
    display: block;
  }
}

// Main Content
.admin-main {
  background: #f5f7fa;
  padding: 24px;
}

// Tablet Dropdown Menu
.admin-menu-btn {
  color: #ffffff !important;
  margin-left: 16px;

  .v-icon {
    font-size: 24px !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }
}

:deep(.admin-menu-dropdown) {
  margin-top: 8px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  min-width: 200px;
}

.admin-menu-list {
  padding: 8px;
  background: #ffffff;
}

.admin-menu-item {
  margin: 2px 0;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: #1f2937 !important;

  .v-icon {
    color: #6b7280 !important;
    transition: color 0.2s ease;
  }

  &:hover {
    background: #f3f4f6 !important;
    color: #1f2937 !important;

    .v-icon {
      color: #3b82f6 !important;
    }
  }

  &.v-list-item--active {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    color: white !important;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);

    .admin-menu-title {
      color: white !important;
      font-weight: 600;
    }

    .v-icon {
      color: white !important;
    }
  }
}

.admin-menu-title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: inherit;
}
</style>
